import { render, staticRenderFns } from "./AppPageHeader.vue?vue&type=template&id=6a9f60ec"
import script from "./AppPageHeader.vue?vue&type=script&lang=js"
export * from "./AppPageHeader.vue?vue&type=script&lang=js"
import style0 from "./AppPageHeader.vue?vue&type=style&index=0&id=6a9f60ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports